import request from './request';

export function addRoomManager(roomId, userId) {
  return request.post('/api/room_manager/add', { room_id: roomId, user_id: userId });
}
export function removeRoomManager(roomId, userId) {
  return request.post('/api/room_manager/remove', { room_id: roomId, user_id: userId });
}
export function getRoomManagers(roomId) {
  return request.get('/api/room_manager/myRoomManagers', { params: { room_id: roomId } });
}
export function banUser(roomId, userId, reason, duration) {
  return request.post('/api/room_manager/ban', { room_id: roomId, user_id: userId, reason, duration });
}
export function unbanUser(roomId, userId) {
  return request.post('/api/room_manager/unban', { room_id: roomId, user_id: userId });
}
export function isBanned(roomId) {
  return request.get('/api/room_manager/isBanned', { params: { room_id: roomId } });
}
export function getMyRooms(params) {
  return request.get('/api/room_manager/myRooms', { params });
}
export function getBanList(params) {
  return request.get('/api/room_manager/banList', { params });
}
export function getLogList(params) {
  return request.get('/api/room_manager/logList', { params });
}
